<template>
  <div class="result">
    <div class="result-data-info">
      为您找到 <span class="number-font">{{$_.get(paging, 'count', '~')}}</span> 个适合售卖 <span class="sell-species">{{$route.query.name}}</span> 的快手达人
    </div>
    <div class="result-data-banner align">
      <div class="index">序号</div>
      <div class="anchor-icon"></div>
      <div class="anchor-info">带货达人</div>
      <div class="level align jus" @click="showHelp()">推荐级别
        <div style="padding-bottom: .1rem">
          <icon type="wenhao" size=".2rem"></icon>
        </div>
      </div>
    </div>
    <div class="result-data-list">
      <router-link :to="`https://m.bihukankan.com/anchor/${$_.get(item, 'anchor.id')}?banner=2`" v-for="(item, index) in resultData" :key="index" class="align item-anchor">
        <div class="index number-font">{{index+1}}</div>
        <div class="anchor-icon"><img :src="($_.get(item, 'anchor.avatar', ''))" alt=""></div>
        <div class="anchor-info">
          <div class="item-name">{{$_.get(item, 'anchor.name')}}</div>
          <div class="item-fans oneLine">粉丝:<span class="number-font">{{$retainWan($_.get(item, 'anchor.fans'))}}</span> 快手号:<span
              class="number-font">{{$_.get(item, 'anchor.userId')}}</span></div>
          <div class="item-tag-contain" v-if="$_.get(item, 'anchor.eCommerceTag.length')>0">
            <div class="default-tag" v-for="(tag, index) in $_.get(item, 'anchor.eCommerceTag')" :key="index">{{tag}}</div>
          </div>
        </div>
        <div class="level align jus">
          <div class="level-radio">{{$_.get(item, 'salesRank')}}</div>
        </div>
      </router-link>
      <LoginOrPayView v-if="hasPay"></LoginOrPayView>
    </div>
    <div class="loading-view align jus" v-if="resultData.length%25!==0&&!hasPay">
      <div class="loading-text">已显示全部结果</div>
    </div>
  </div>
</template>

<script>
  const params = {
    page: 25,
    index: 1,
    sort: 'salesRank',
    order: 'desc',
    name: '',
  }
  export default {
    data() {
      return {
        params,
        paging: {},
        resultData: [],
        // 实际应该直接在template中判断的，但是原来写错了
        // 直接在返回中进行了处理
        // 所以也没有改
        // 新加了key
        hasPay: false
      }
    },
    mounted() {
      this.params = {
        ...this.params,
        name: this.$route.query.name,
        priceIndex: Number(this.$route.query.priceIndex)
      }
      this.query()
      this.addListenScroll()
    },
    beforeDestroy() {
      window.onscroll = {}
    },
    methods: {
      showHelp() {
        this.$dialog.alert({
          message: '推荐级别由高到低分为S、A、B、C、D五个等级。由当前达人在统计周期内，通过快手平台售卖此类商品的销售数据加权计算得出。级别越高，说明该达人对此类商品的潜在带货能力越强。'
        }).then(() => {
          // on close
        });
      },
      query() {
        this.$showLoading()
        this.$get({
            road: 'commodityRecommend',
            data: {
              road: 'gifshow'
            },
            params: this.params,
            version: 'v2'
          })
          .then(res => {
            this.loading = false
            this.$toast.clear()
            this.paging = res.paging
            this.hasPay = this.$_.last(res.data).businessPackageSceneAlias
            this.resultData = this.resultData.concat(res.data.filter(ele=>{return !ele.businessPackageSceneAlias}))
          })
          .catch(err => {
            this.loading = false
            this.$toast('查找失败')
          })
      },
      addListenScroll() {
        function getScrollTop() {
          var scrollTop = 0;
          if (document.documentElement && document.documentElement.scrollTop) {
            scrollTop = document.documentElement.scrollTop;
          } else if (document.body) {
            scrollTop = document.body.scrollTop;
          }
          return scrollTop;
        }
        // 获取当前可视范围的高度 
        function getClientHeight() {
          var clientHeight = 0;
          if (document.body.clientHeight && document.documentElement.clientHeight) {
            clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
          } else {
            clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
          }
          return clientHeight;
        }

        // 获取文档完整的高度 
        function getScrollHeight() {
          return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        }

        window.onscroll = () => {
          if (getScrollTop() + getClientHeight() == getScrollHeight() && !this.loading && this.paging.index>=1 && this.resultData.length%25===0) {
            this.loading = true
            this.params = {
              ...this.params,
              index: this.paging.index + 1
            }
            this.query()
          }
        };
      }
    },
  }
</script>

<style lang="less" scoped>
  .result {
    background: #EEF2F7;

    .result-data-info {
      background: #fff;
      text-align: center;
      line-height: 0.6rem;
      height: 0.6rem;
      color: #A1AEBF;

      .number-font {
        color: #4A4A4A;
      }

      .sell-species {
        color: #FF5500;
      }
    }

    .result-data-banner,
    .result-data-list {

      .index {
        width: 0.6rem;
      }

      .anchor-icon {
        width: 1rem;
        height: 1rem;
        border-radius: 100%;
        overflow: hidden;
        margin-right: 0.1rem;

        img {
          width: 1rem;
          height: 1rem;
        }
      }

      .anchor-info {
        width: 4.0rem;
      }

      .level {
        width: 1.2rem;
      }
    }

    .result-data-banner {
      height: 0.6rem;
      line-height: 0.6rem;
      color: #A1AEBF;
      font-size: .2rem;
      width: 7.5rem;
      padding: 0 .3rem;
    }

    .result-data-list {
      .item-anchor {
        width: 7.5rem;
        padding: 0 .3rem;
        background: #fff;
        height: 1.8rem;
        margin-bottom: 0.1rem;

        .anchor-info {

          .item-name {
            color: #4A4A4A;
            font-size: .28rem;
            width: 3.5rem;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap;
          }

          .item-fans {
            color: #A1AEBF;
            font-size: .2rem;
            margin-top: 0.2rem;
          }

          .item-tag-contain {
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            height: 0.3rem;
            margin-top: 0.2rem;

            .default-tag {
              height: 0.3rem;
              line-height: 0.3rem;
              padding: 0 .1rem;
              background: rgba(202, 211, 223, 0.3);
              border-radius: .3rem;
              margin-right: .1rem;
              font-size: .2rem;
              color: #A1AEBF;
            }
          }
        }

        .level {
          .level-radio {
            width: 0.9rem;
            height: 0.9rem;
            background: rgba(255, 85, 0, .1);
            border-radius: 100%;
            color: #FF5500;
            font-size: .48rem;
            text-align: center;
            line-height: .9rem;
          }
        }
      }
    }

  }

  .loading-view {
    color: #A1AEBF;
    height: 1rem;
    .loading-icon {
      animation: turnLoading 1.8s linear infinite;
    }
    .loading-text {
      margin-left: 0.2rem;
    }
  }
  @keyframes turnLoading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>